import React, { useEffect, useRef, useState } from 'react';
import CameraSVGIcon from '../../components/icons/CameraIcon';
import default_user_pic from '../../assets/images/user_bydefalut_img_sport_select.png';
import { useSnackbar } from 'notistack';
import { uploadImage, RemoveImage } from '../../API/player';
import Swal from 'sweetalert2';

const ImageUpload = ({ profile }) => {
  // console.log("profile", profile)
  const [previewSrc, setPreviewSrc] = useState(default_user_pic);
  const [file, setFile] = useState();
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const fileInputRef = useRef(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
  const [userPhoto, setUserPhoto] = useState(null);
  const [userPhotoUploaded, setUserPhotoUploaded] = useState(false);
  const [userPhotoRemoved, setUserPhotoRemoved] = useState(false);
  const [alredyUploaded, setallReadyUploaded] = useState(false);


  useEffect(() => {
    if (profile && profile.profile_image) {
      setUserPhoto(profile.profile_image);
      setallReadyUploaded(true);
    }
  }, [profile])
  const handleImageClick = () => {
    if (!userPhoto) {
      fileInputRef.current.click();
    }
  };

  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviewSrc(reader.result);
  //       setIsImageUploaded(true); // Set this to true when a file is selected
  //     };
  //     reader.readAsDataURL(file);
  //   }

  //   const fileUpload = new FormData();
  //   fileUpload.append('file', event.target.files[0]);
  //   let res = await uploadImage(fileUpload);
  //   if (res.status) {
  //     enqueueSnackbar('Profile photo has been uploaded', { variant: 'success' });
  //   } else {
  //     enqueueSnackbar('Unable to update profle photo', { variant: 'error' });
  //   }
  // };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      let validSubmit = false;
      const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

      // Generate image previews

      if (!validImageTypes.includes(selectedFile.type)) {
        Swal.fire({
          title: 'Image format not supoorted',
          text: 'You can only upload image of following format. webp, jpg, png, jpeg',
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        event.target.value = ''; // Clear the file input
        return;
      } else {
        validSubmit = true;

      }
      if (validSubmit) {

        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewSrc(reader.result);
          setIsImageUploaded(true);
        };
        reader.readAsDataURL(selectedFile);

        const fileUpload = new FormData();
        fileUpload.append('file', selectedFile);
        setUserPhotoUploaded(true)
        let res = await uploadImage(fileUpload);
        if (res.status) {
          enqueueSnackbar('Profile photo has been uploaded', {
            variant: 'success', action: (key) => (
              <button className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          });
        } else {
          enqueueSnackbar('Unable to update profile photo', {
            variant: 'error', action: (key) => (
              <button className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          });
        }

        // Reset the file input
        event.target.value = null; // This resets the input
      }
    }
  };

  const handelRemoveImage = async (e) => {
    let removeImage = await RemoveImage();
    if (removeImage.status) {
      setPreviewSrc(default_user_pic)
      setUserPhotoRemoved(true)
      setUserPhoto(null)
      setUserPhotoUploaded(false)
      enqueueSnackbar('Profile photo has been removed', {
        variant: 'success', action: (key) => (
          <button className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key);
            }}
          >
            X
          </button>
        ),
      });
    }
  }

  return (
    <div className='d-flex justify-content-center flex-column'>
      <img
        className='image--cover new_image--cover '
        src={userPhoto != null && userPhotoRemoved == false ? IMAGE_URL + "user/" + userPhoto : previewSrc}
        alt="Click to upload"
        style={{
          border: isImageUploaded ? '2px solid rgb(245 98 193)' : 'none' // Apply border conditionally
        }}
        onClick={handleImageClick}
        key={previewSrc}
      />
      <p className='remove_btn_img_main_div' style={{ display: alredyUploaded == true || userPhoto === null && userPhotoUploaded == false ? "none" : "block" }}
      >
        <button className='sport_select_img_removebtn' onClick={(e) => handelRemoveImage(e)}>
          <i class="bi bi-x"></i>
        </button>
      </p>

      <input
        type="file"
        ref={fileInputRef}
        accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
        style={{ display: 'none' }}
        id="photo" name="photo"
        onChange={handleFileChange}
      />

    </div>
  );
};

export default ImageUpload;
